"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const historyMockItems = [
    {
        id: "0",
        name: "Wissel Fat Burning naar Pregnancy",
        origin: "Member",
        createdAt: "2021-09-16T11:01:45+00:00",
    },
    {
        id: "1",
        name: "Wijziging in caloriebudget",
        origin: "System",
        createdAt: "2021-09-16T11:02:45+00:00",
    },
    {
        id: "2",
        name: "Wijziging in caloriebudget",
        origin: "Member",
        createdAt: "2021-09-16T11:03:15+00:00",
    },
];
class HistoryMock {
    constructor() {
        this.getHistory = (_memberId) => {
            return Promise.resolve({ items: historyMockItems, isMore: false });
        };
        this.getHistoryAfter = (_memberId, _eventId) => {
            return Promise.resolve({ items: [], isMore: false });
        };
    }
}
exports.default = HistoryMock;
//# sourceMappingURL=History.js.map